import React from 'react';
import { withStyles, makeStyles } from '@mui/styles';
import { Accordion, AccordionSummary, AccordionDetails, Typography} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

//Note: CategoryAccordians not currently in use as long as use the layer search/filtering scheme

const useStyles = makeStyles((theme) => ({
    accordionText: {
        fontSize: '90%',
    },
}));

const CategoryAccordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(Accordion);

const CategoryAccordionSummary = withStyles({
  root: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: '0.0em',
    '&$expanded': {
      minHeight: '1em',
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(AccordionSummary);

const CategoryAccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
  },
}))(AccordionDetails);

/**
*   MenuCategory: Used to create expandable menu categories
*   - This is a controlled component, state for whether the category is open or closed must be maintained elsewhere
*   - Pass a category name and customize color with css classOverride
*   - Pass any child components to be displayed within the expanded category
*
*   @prop (obj) classOverride - additional css to apply to category header only
*   @prop (bool) catOpen - state t/f, opened/closed of category (for Accordion)
*   @prop (func) seCatOpen - setter for changing value of catOpen
*   @prop (string) categoryName - Text to be displayed in AccordionSummary (name of category)
*   @prop (jsx) children - any components to be displayed within the expanded category
*
*/
function MenuCategory(props){
    const classes = useStyles();
    return(
        <CategoryAccordion expanded={props.catOpen} onChange={() => {props.setCatOpen(!props.catOpen)}}>
            <CategoryAccordionSummary
                style={props.styleOverride}
                className={props.classOverride} // This may be a poor choice, consider refactoring <------------REFACTOR
                expandIcon={<ExpandMoreIcon />}
            >
                <Typography className={classes.accordionText}>{props.categoryName}</Typography>
            </CategoryAccordionSummary>
            <CategoryAccordionDetails>
                {props.children}
            </CategoryAccordionDetails>
        </CategoryAccordion>
    );
}

export default MenuCategory;